import React from 'react';

export function DiabeticFeet() { // Named export instead of default
  return (
    <div>
      <h2>Diabetic Feet Care</h2>
      <p>We offer comprehensive treatment for diabetic foot conditions...</p>
    </div>
  );
}
